import firebase_api from '@/firebase/firebase_api'
import mail_fct from '@/firebase/mails'
import user_fct   from  '@/firebase/user'
import firebase from 'firebase/app';
import util 		  	from '@/util/tools'
import joueurObject from '@/firebase/joueur'
import cyptoJs from 'crypto-js';
const { v4: uuidv4 } = require('uuid');
const object = {
    data: {
        name: "",
        id: null,
        users: {},
        type: 0,
        description: "",
        urlsite: "",
        comite: "",
        numero: "",
        public: true,
        tel: "",
        president: "",
        adhesion: true,
        customs: {
            MEMBRE: {
                id: 'MEMBRE',
                type: 'radio',
                label: 'Membre :',
                values: ['NON', 'OUI'],
                filter: true,
                private: false,
                valuesDefault: 0
            }
        }
    },
    async save(club, user) {
       
        var status = {
            success: true,
            errorLength: false,
            errorExist: false
        }
        if (club.name.length < 3) {
            status.errorLength = true;
        }
        else {
            // important de mettre ça avant 
            club.search = club.name.toUpperCase();
            status.errorExist = await this.existClubByName(club);
            
            if (!status.errorExist) {
                if (club.id==null) {
                    club.id = util.tools.StringToId(club.name).toLowerCase();
                    status.errorExist = await this.existClub(club.id);
                }
            }
            
              
        }
        status.success = !(status.errorExist || status.errorLength);
        if (status.success)  {
            club.users[user.authId] = user;
            await firebase_api.api.getDb().collection("club").doc(club.id).set(club);
            
        }
        return status;
    },
    getIdUser (joueur, fct) {
        if (joueur.email != "") {
            firebase_api.api.getDb().collection("user").doc(joueur.email).get().then(snapshot=>{
                if (snapshot.exists)
                    fct(snapshot.id);
                else
                    fct(null);
            });
        }
        else
            fct(null);
    },
    async deleteInvite (joueur, club, idTournoi) {
        
        var snapshot = await firebase_api.api.getDb().collection("user").doc(joueur.email).get();
        
        var clubs = snapshot.data().clubs;
        var indexClub = clubs.findIndex(clubItem=>clubItem.idClub === club.id);
      
        if (typeof(clubs[indexClub].invites)!="undefined") {
           
            var indexInvite = clubs[indexClub].invites.indexOf(idTournoi);
            if (indexInvite!=-1) {
                clubs[indexClub].invites.splice(indexInvite, 1);
                if (clubs[indexClub].invites.length==0) 
                    clubs.splice(indexClub, 1);
                snapshot.ref.update({
                    clubs: clubs
                })
            }
        }
    },
    async addUser(joueur, club, batch, idTournoi) {
        return new Promise(async (resolve, reject)  =>  {
            joueur.email = joueur.email.trim();
            var snapshot = await firebase_api.api.getDb().collection("user").doc(joueur.email).get();
            var userRef = null;
            var user = null;
            var indexClub = -1;
            if (snapshot.exists) {
            
                userRef = snapshot.ref;
                var user = snapshot.data();
                if (typeof(user.clubs) == "undefined") {
                    user.clubs = [];
                }
            }
            else {
              
                userRef = firebase_api.api.getDb().collection("user");
                userRef = userRef.doc(joueur.email);
                user = {
                    displayName: joueur.pseudo,
                    email: joueur.email,
                    clubs: [],
                    login: false,
                    id: joueur.email
                }
            }
            // Maintenant qu'on a initialise le user
            // il faut mettre le club dans l'attribut clubs
            // on vérifie si ce joueur est déjà dans le club
         
            var indexClub = user.clubs.findIndex(clubItem=>clubItem.idClub===club.id);
            if (indexClub == -1) {
                var clubItemUser = {
                    idClub: club.id,
                    idJoueur: joueur.id,
                    nameClub: club.name
                }
            }
            else {
                var clubItemUser = user.clubs[indexClub];
            }
            // On a initialiser cluITEM
            // Maintenant il faut ajouter idTournoi dans invite si il a été mis ou le supprimer si il a pas été transmis!
            var majInvite = true;
            var sendMailInvite = false;
            var sendMembre = false;
            if (typeof(clubItemUser.invites)!="undefined") {
                if (typeof(idTournoi)=="undefined") {
                    delete clubItemUser.invites;
                    sendMembre = true;
                    // DU COUP IL DEVIENT MEMBRE !
                }
                else {
                    var indexTournoi = clubItemUser.invites.indexOf(idTournoi);
                    if (indexTournoi==-1) {
                        clubItemUser.invites.push(idTournoi);
                        sendMailInvite = true;
                    }
                    else
                        majInvite = false;
                }
            }
            else {
                if (typeof(idTournoi)!="undefined") {
                    clubItemUser.invites = [];
                    clubItemUser.invites.push(idTournoi);
                    sendMailInvite = true;
                }
                else
                    majInvite = false;
            }
            clubItemUser.idClub = club.id;
            clubItemUser.idJoueur = joueur.id;
            clubItemUser.nameClub = club.name;

            if (indexClub == -1) {
                user.clubs.push(clubItemUser);
            } 
            else {
                user.clubs[indexClub] = clubItemUser;
            }
           
            // on met à jour que si on a ajouter dans invites du club ou qu'il y a un nouveau club
            if (majInvite || indexClub==-1) { 
                await batch.set(userRef, user);
            }
            // envoie du mail
             
            var params = {
                url: window.location.origin,
                idClub: club.id,
                club: club.name,
                email: joueur.email
            }
            
            var demo = typeof(club.demo) == "undefined" ? false : club.demo;
            if (!demo) {
                if (sendMailInvite) {
                    await mail_fct.object.sendEmailByBatch(batch, joueur.email, "MEMBRE_INVITE", params);
                }
                else if (indexClub==-1 || sendMembre) {
                    await mail_fct.object.sendEmailByBatch(batch, joueur.email, "MEMBRE_OK", params);
                }
            }
            user.id = user.email;
            resolve(user); 
        })
    },
    async removeJoueurs(club) {
        var clubDoc = firebase_api.api.getDb().collection("club").doc(club.id);
        await clubDoc.collection("joueurs").get().then(async (docJoueur)=>{
            docJoueur.docs.forEach(async(docItemJoueur)=>{
                await docItemJoueur.ref.delete();
            })
        })
    },
    async setAdmin(club, joueur, userData, batch) {
        
        if (joueur.userId!='' && joueur.userId!=null) {
            
            var clubDoc = firebase_api.api.getDb().collection("club").doc(club.id);
            var docClub = await clubDoc.get();
            if (docClub.exists) {
               
                var users = docClub.data().users;
                var maj = true;
                var idAuth = userData.authId;
                
                
                if (typeof(users[idAuth]) != "undefined") {
                        if (users[idAuth].role != 'owner')
                            if (joueur.admin)
                                users[idAuth].role = 'admin';
                            else
                                delete users[idAuth];
                        else
                            maj=false;
                }
                else {
                  
                    if (joueur.admin) {
                        var dataUser = {
                            authId: idAuth,
                            email: userData.email,
                            pseudo: userData.displayName,
                            id: userData.id,
                            role: "admin"
                        }
                        users[idAuth] = dataUser;
                    }
                }
                            
                if (maj) {
                    await batch.update(docClub.ref, { users: users });
                }
            }
            }
        
    },
    async addJoueur(club, joueur, batch, importationId, fct) {
       
        var clubDoc = firebase_api.api.getDb().collection("club").doc(club.id);
        var errorEmailExist = false;
        var addJoueur = joueur.id==null;
        joueur.isLicencie = joueur.licence!='';
        // je regarde si j'ai un joueur avec un email
        if (joueur.email != "") {
            var docJoueur  = await clubDoc.collection("joueurs").where("email","==",joueur.email).get();
            if (docJoueur.size!=0)
                errorEmailExist = joueur.id != docJoueur.docs[0].id;
        }
       
        if (errorEmailExist) {
            joueur.emailParent = joueur.email;
            joueur.email = "";
            // il faut mettre le parent du joueur
            var joueurParent = docJoueur.docs[0].data();
            if (typeof(joueurParent.children)=="undefined") 
                joueurParent.children = [];
            if (joueurParent.children.findIndex(elt=>elt === joueur.id)==-1) {
                joueurParent.children.push(joueur.id);
                clubDoc.collection("joueurs").doc(docJoueur.docs[0].id).update({
                    children: joueurParent.children
                })
            }

        }
        var joueurRef= null;
        if (joueur.id!=null) {
                joueurRef = clubDoc.collection("joueurs").doc(joueur.id);
                var joueurExist = await joueurRef.get();
                addJoueur = !joueurExist.exists;
        }
        if (addJoueur) {
            if (importationId!=null)
                joueur.importation = importationId;
            joueur.id = clubDoc.collection("joueurs").doc().id;
        }
        joueurRef = clubDoc.collection("joueurs").doc(joueur.id);
        
        await batch.set(joueurRef,joueur);
        
        if (joueur.email != "") {
            var user = await this.addUser(joueur, club, batch);
            if (user != null) {
                    joueur.userId = user.id;
                    var elo = typeof(user.elo) == "undefined" ? 1199 : user.elo;
                    joueur.elo = elo;
            }
            else
                joueur.userId = null
            joueurRef =  clubDoc.collection("joueurs").doc(joueur.id);
            await batch.set(joueurRef,joueur);
            
            await this.setAdmin(club, joueur, user, batch,()=>{});
        }
        fct(addJoueur);
    
       
    },
    delete(clubId, fct) {
        firebase_api.api.getDb().collection("club").doc(clubId).delete()
            .then (()=>{
                fct();
            })
    },
    async existClub(idClub) {
        var clubDoc = await firebase_api.api.getDb().collection("club").doc(idClub).get();
        return (clubDoc.exists)
    },
    async existClubByName(club) {
        var clubDoc = await firebase_api.api.getDb().collection("club").where("search", "==", club.search).get();
        if (club.id == null)
            return (clubDoc.docs.length!=0)
        else {
            if (clubDoc.docs.length==0) {
                return false;
            }
            else if (clubDoc.docs.length!=1) {
                return true;
            }
            else {
                return clubDoc.docs[0].id != club.id;
            }
        }
    },
    
    get(idClub, fct) {
      
        var clubRef = firebase_api.api.getDb().collection("club").doc(idClub);
        clubRef.get().then(club=>{
          
            fct(club.data());
        }).catch(err=>{
            console.log(err);
        })
    },
    set(club, fct) {       
        firebase_api.api.getDb().collection("club").doc(club.id).set(club)
            .then(()=>{
                fct();
            })
            .catch((error)=> {
                firebase_api.api.setLog("club", "set", error);
            });
    },
    async refusDemande(club, demande) {
        var userRef = firebase_api.api.getDb().collection("user").doc(demande.id);
        var userDoc = await userRef.get();
        var userData = userDoc.data();
        var demandes = userData.demandes;
        demandes[club.id].status = false;
        userRef.update({
            demandes: demandes
        })
        var demandeRef = firebase_api.api.getDb().collection("club").doc(club.id).collection("demandes").doc(demande.id);
        var demandeDoc = await demandeRef.get();
        var demandeData = demandeDoc.data();
        demandeData.status = false;
        demandeRef.update({
            status: demandeData.status
        })
        var params= {
            club: club.name,
            idClub: club.id,
            url: window.location.origin
        }
        mail_fct.object.sendEmail(demande.id, "ADHESION_REFUS", params);
    },
    supprimerDemande(club, demande) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("demandes").doc(demande.id).delete();
       
        firebase_api.api.getDb().collection("user").doc(demande.id).get().then(user=>{
           
            if(typeof(user.data().demandes) != "undefined") {
                var demandes = user.data().demandes;
                delete demandes[club.id];
               
                user.ref.update({
                    demandes: demandes
                })
            }
        });
    },
    demandeMembre(club, userOwner, user , joueur) {
        var demande = {
            idClub: club.id,
            status: null,
            nom: joueur.nom,
            prenom: joueur.prenom,
            idUser: user.id
        }
        if(typeof(user.demandes) == "undefined") {
            user.demandes = {}
        }
        user.demandes[club.id] = demande;
        firebase_api.api.getDb().collection("user").doc(user.id).update({
            demandes: user.demandes
        })
        firebase_api.api.getDb().collection("club").doc(club.id).collection("demandes").doc(user.email).set(user);
        // envoyer un mail
        var params= {
            club: club.name,
            idClub: club.id,
            nom: joueur.nom,
            prenom: joueur.prenom,
            url: window.location.origin
        }
        mail_fct.object.sendEmail(userOwner.email, "ADHESION_DEMANDE", params);
       
    },
    async createClubDemo(user, idClubCopy) {
        var clubDemo = firebase_api.api.getDb().collection("club").doc(idClubCopy);
        var clubDemoDoc = await clubDemo.get();
        var clubDemoData = clubDemoDoc.data();
        clubDemoData.users = {};
        clubDemoData.users[user.authId] = {
                authId : user.authId,
                email: user.email,
                id: user.email,
                pseudo: user.displayName,
                role: "owner"
        }
        clubDemoData.demo = true;
        var today = new Date();
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        clubDemoData.create = today.getTime();
        clubDemoData.public = false;
        var clubAdd = await firebase_api.api.getDb().collection("club").add(
            clubDemoData
        )
        firebase_api.api.getDb().collection("club").doc(clubAdd.id).update({
            id: clubAdd.id
        })
        firebase_api.api.getDb().collection("club").doc("demo").collection("joueurs").get().then(async joueurs=>{
            joueurs.docs.forEach(async doc=>{
                var joueurItem = doc.data();

                var JoueurAdd = await firebase_api.api.getDb().collection("club").doc(clubAdd.id).collection("joueurs").add(
                   joueurItem 
                )
                firebase_api.api.getDb().collection("club").doc(clubAdd.id).collection("joueurs").doc(JoueurAdd.id)
                .update({
                    id: JoueurAdd.id
                })
            })
        })
        return clubAdd.id;
    },
    setTuto (club) {
        if (club.demo)
            firebase_api.api.getDb().collection("club").doc(club.id).update({
                tuto: club.tuto
            })
    },
    async changeProprietaire(club, user, joueur, fct) {
        var returnFct = false;
        if (typeof(joueur.userId)!="undefined") {

            firebase_api.api.getDb().collection("user").doc(joueur.userId).get().then(async (userRef)=>{
                if (userRef.exists) {
                    var userJoueur = userRef.data();
                   
                    if (userJoueur.login) {
                        // on met dans clubs.users le nouveau GESTIONNAIRE (=owner)
                        var authId = userJoueur.authId;
                        var userInClub = club.users[authId];
                        if (typeof(userInClub)=="undefined") {
                            // il ne le trouve pas il faut le creer
                            var userAddInClub = {
                                authId: userJoueur.authId,
                                email: userJoueur.email,
                                id: userJoueur.id,
                                pseudo: joueur.pseudo,
                                role: "owner"
                            }
                            club.users[authId] = userAddInClub;
                        }
                        else {
                            // ici on le met à jour
                            club.users[authId].role = "owner"
                        }
                        // du coup on doit enlever l'ancien GESTIONNAIRE (owner) pour le mettre ORGANISATEUR (admin)
                        if (club.users[user.authId] != "undefined") {
                            // NORMALEMENT ON DOIT TOUJOURS LE TROUVER
                            club.users[user.authId].role = "admin";
                            // On trouve à quel joueur il correspond 
                            // normalement il doit avoir dans clubs user
                            var indexJoueur = user.clubs.findIndex(clubItem=>{
                                if (typeof(clubItem)!="undefined")
                                    return (clubItem.idClub == club.id)
                                else
                                    return false;
                            })
                           
                            if (indexJoueur!=-1) {
                                // ICI on l'a trouve du coup on met le joueur courant en tant ADMIN
                                var idJoueur = user.clubs[indexJoueur].idJoueur;
                                await firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs").doc(idJoueur).update({
                                    admin: true
                                })
                            }
                            else {
                                // cela signfie que le gestionnaire d'origine n'était pas MEMBRE
                                // du coup il faut qu'il le soit pour le mettre en tant que ORGANISATEUR c à dire admin
                                //await firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs").where(idJoueur).
                                var joueurAdd = JSON.parse(JSON.stringify(joueurObject.object.data));
                                
                                joueurAdd.nom = user.displayName;
                                joueurAdd.email = user.email;
                                joueurAdd.idClub = club.id;
                                joueurAdd.admin = true;
                                joueurAdd.userId = user.email;
                                joueurAdd.pseudo = joueurAdd.nom.substr(0,7).toUpperCase();
                                var batch = firebase_api.api.getDb().batch();
                                this.addJoueur(club, joueurAdd, batch, null, (err)=>{
                                    batch.commit();
                                });
                            }
                           
                            // on met également en tant qu'ADMIN le joueur qui devient GESTIONNAIRE
                            await firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs").doc(joueur.id).update({
                                admin: true
                            })

                            // ICI on ne s'embete on remet à jour tous les users
                            await firebase_api.api.getDb().collection("club").doc(club.id).update({
                                users: club.users
                            }).then(()=>{
                                returnFct = true;
                                fct(true);
                            })
                        }
                    }
                }
            })
        }
        if (!returnFct)
            fct(false)
    }
    


    
}


export default {
	object: object
}